import { JobsLogListAPI } from 'ducks/types/api-types';
import { LogsItem } from 'ducks/types/store-types';
import moment from 'moment';
import { formatDate, offsetTimezoneUTC } from 'utils/dates';
import { v4 as uuidv4 } from 'uuid';

import 'moment-duration-format';

export const normalizeLogs = (logs: JobsLogListAPI[]): LogsItem[] =>
  logs
    .map((log, i) => {
      const next_log = logs[i + 1];

      let duration_seconds = 0;
      let terminal_log = false;

      if (next_log) {
        duration_seconds = moment(next_log.datetime_utc).diff(log.datetime_utc, 'seconds');
      } else {
        duration_seconds = moment().diff(log.datetime_utc, 'seconds');
      }

      if (log.job_state_id === 4 || log.job_state_id === 98 || log.job_state_id === 99) {
        terminal_log = true;
      }

      return {
        ...log,
        terminal_log,
        duration_seconds,
        duration_days_masked: moment.duration(duration_seconds, 'seconds').format('d[d]'),
        duration_hours_masked: moment.duration(duration_seconds, 'seconds').format('d[d] h[h]'),
        duration_minutes_masked: moment.duration(duration_seconds, 'seconds').format('d[d] h[h] m[m]'),
        duration_seconds_masked: moment.duration(duration_seconds, 'seconds').format('d[d] h[h] m[m] s[s]'),
        duration_days_show: duration_seconds > 864000, // 10 day
        duration_hours_show: duration_seconds > 86400, // 1 day
        duration_minutes_show: duration_seconds > 3600, // 1 hour
        datetime_utc_formatted: formatDate(log.datetime_utc, { format: 'M/D/YY h:mm:ss A' }),
        datetime_formatted: offsetTimezoneUTC(log.datetime_utc, { format: 'M/D/YY h:mm:ss A' }),
        job_state_name_formatted: log.job_state_name.split('-')[1],
        uuid: uuidv4(),
      };
    })
    .sortObject('datetime_utc', 'desc');
